import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { LoginService } from 'src/app/Service/login.service';
import { CommonService } from 'src/app/Service/Common.service';
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { DataFormatService } from 'src/app/Service/data-format.service';
import { UserDetailsViewModel } from 'src/app/ViewModel/UserDetailsModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { IElasticProjRedirectModel } from 'src/app/ViewModel/ElasticSearch.Model';

@Component({
	selector: 'edms-common-header',
	templateUrl: './edms-common-header.component.html',
	styleUrls: ['./edms-common-header.component.css']
})
export class EdmsCommonHeaderComponent implements OnInit {

	@Input()
	showProjectList!: boolean;
	@Input()
	showDateDetails!: boolean;
	@Input()
	pageTitle!: string;

	loggedinUserId!:number ;
	projectList: ProjectViewModel[] = [];
	projectDetail!: ProjectViewModel;
	projectStartDate!: string|null;
	projectEndDate!: string|null;
	diffInYears!: number|null;
	daysCompletionPercentage!: number;
	projectForm!: FormGroup;
	isPageRefreshRequired: boolean = false;
	selectedProject!: ProjectViewModel;
	elasticProjModel!: IElasticProjRedirectModel;
	constructor(private commonService: CommonService, private dataFormatService: DataFormatService, private projectInfoService: ProjectInfoService, private notificationService: NotificationService, private loginService: LoginService, private formBuilder: FormBuilder, private router: Router, private encryptDecryptService: EncryptDecryptService) {
	}

	ngOnInit() {
		this.loggedinUserId = this.commonService.getLoggedInUserId();
		this.createprojectForm();
		this.getProjectList();
	}

	createprojectForm() {
		this.projectForm = this.formBuilder.group({
			project: new FormControl('', [Validators.required])
		});
	}

	getProjectList() {
		this.projectInfoService.getProjectList(this.loggedinUserId).subscribe((data: ProjectViewModel[]) => {
			let allProject: ProjectViewModel = {
				endDate: null,
				jobCode: "All",
				projectType: "Other",
				projectCode: "All",
				projCodeDesc: "All",
				projectDescription: "All",
				projectId: 9999999,
				projectLogoURL: null,
				projectShortDescription: "All",
				projectURL: null,
				startDate: null,
				isCloudStorage: false,
				isCommonWorkflow: false
			}
			this.projectList.push(allProject);
			this.projectList = this.projectList.concat(data);
			for (let i = 0; i < this.projectList.length; i++) {
				this.projectList[i]['projCodeDesc'] = this.projectList[i].projectCode + ' - ' + this.projectList[i].projectDescription;
			}
			if (this.commonService.hasRequestedObject()) {/*Mail Redirection*/
				var requestedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('requestedObject')));
				let requestedProject = this.projectList.filter(item => item.projectId.toString() == requestedObject['project']);

				if (requestedProject.length > 0) {
					this.setProjectData(requestedProject[0]);
				}
			}
			else {
				this.loginService.GetMemberProjectSelection({ "projectId": null, "userId": this.loggedinUserId, }).subscribe((data: any) => {
					if (data) {
						let event = this.projectList.filter(item => item.projectId === data['projectId']);
						if (event && event.length > 0) {
							this.setProjectData(event[0]);
						}
						else {
							this.setProjectData(this.projectList[0]);
						}
					}
				});
			}
		});
	}

	public changeProjectFromES(elasticProjModel: IElasticProjRedirectModel) {
		let newProject: ProjectViewModel = this.projectList.filter(x => x.projectId == elasticProjModel.projectId)[0];
		if (!!newProject) {
			this.elasticProjModel = elasticProjModel;
			this.changeProject(newProject);
		}
	}
	reloadProject: boolean = false;
	changeProject(event: ProjectViewModel) {
		if (this.selectedProject != null && Number(event) != -1) {
			this.notificationService.showPopup("Are you want to change project ? ", 'Confirm').then(data => {
				if (data == 'yes') {
					this.setProjectData(event);
					this.reloadProject = true;
				} else {
					this.projectForm.get('project')?.setValue(this.selectedProject);
				}
			});
		} else {
			if (Number(event) != -1) {
				this.setProjectData(event);
			}
		}
	}

	setProjectData(event: ProjectViewModel ) {
		this.selectedProject = event;
		if (this.projectForm.get('project')?.value == '') {
			this.projectForm.get('project')?.setValue(this.selectedProject);
		}
		this.getProjectDetails(this.loggedinUserId, this.selectedProject.projectId);
	}

	public getProjectDetails(userId: number, projectId: number) {
		this.projectInfoService.getProjectDetails(projectId, userId).subscribe((data: ProjectViewModel[]) => {
			if (projectId == 9999999) {
				this.projectList.filter(x => x.projectId == 9999999).map(y => data.splice(0, 0, y));
			}
			if (!!data) {
				this.projectDetail = data[0];
				if (this.projectDetail) {
					let user = {
						memberId: userId,
						projectId: this.projectDetail.projectId,
						isInternal: this.commonService.getLoggedInUserStatus()
					}

					this.loginService.GetCurrentUserDetails(user).subscribe((data: any) => {
						if (data["successCode"] === 200) {
							this.commonService.setCurrentUserProfileCard(data);
							this.commonService.setProjectCode(this.selectedProject.projectCode, this.selectedProject.projectId, this.selectedProject);
							this.calculateDates();
							if (!!this.elasticProjModel) {
								if (this.projectDetail.projectId == 9999999) {
									this.router.routeReuseStrategy.shouldReuseRoute = () => false;
									this.router.onSameUrlNavigation = 'ignore';
									this.router.navigate(['/dashboard/home']);
								} else {
									this.router.routeReuseStrategy.shouldReuseRoute = () => false;
									this.router.onSameUrlNavigation = 'reload';
									this.router.navigate([this.elasticProjModel.redirectUrl]);
								}
							}
							else {
								if (this.isPageRefreshRequired) {
									if (this.projectDetail.projectId == 9999999) {
										this.isPageRefreshRequired = true;
										this.router.routeReuseStrategy.shouldReuseRoute = () => false;
										this.router.onSameUrlNavigation = 'ignore';
										this.router.navigate(['/dashboard/home']);
									}
									else {
										this.isPageRefreshRequired = true;
										this.router.routeReuseStrategy.shouldReuseRoute = () => false;
										this.router.onSameUrlNavigation = 'reload';
										this.router.navigate([this.router.url]);
									}
								} else {
									if (this.projectDetail.projectId == 9999999) {
										this.isPageRefreshRequired = true;
										this.router.routeReuseStrategy.shouldReuseRoute = () => false;
										this.router.onSameUrlNavigation = 'ignore';
										this.router.navigate(['/dashboard/home']);
									}
								}
							}
							this.isPageRefreshRequired = true;
							if (this.reloadProject) {
								this.reloadProject = false;
								window.location.reload();
							}
						}
						else {
							this.notificationService.showPopup('Invalid credential', "Warning").then(
								x => this.loginService.Logout(this.commonService.getLoggedInUserStatus())
							);
						}
					});
				}
			}
		});
	}

	public calculateDates() {
		
		this.projectStartDate = this.dataFormatService.formatDate(this.projectDetail.startDate);
		this.projectEndDate = this.dataFormatService.formatDate(this.projectDetail.endDate);
		this.diffInYears = this.dataFormatService.getDiffBtwDates(this.projectDetail.startDate, this.projectDetail.endDate, 'years');
		
		let totalDays = this.dataFormatService.getDiffBtwDates(this.projectDetail.startDate, this.projectDetail.endDate),
			completedDays = this.dataFormatService.getDiffBtwDates(this.projectDetail.startDate, new Date().toISOString())
			if(totalDays && completedDays)
			{
				let percentage:any = (completedDays / totalDays) * 100;
			this.daysCompletionPercentage = Math.round(percentage);
			}
	}
}
